var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4Columns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#4columns_svg__filter0_d_2083_169449)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 64,
    height: 64,
    rx: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.75,
    height: 48,
    rx: 2,
    transform: "matrix(1 0 0 -1 10 57)",
    fill: "#D1D4DC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.75,
    height: 48,
    rx: 2,
    transform: "matrix(1 0 0 -1 22.75 57)",
    fill: "#D1D4DC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.75,
    height: 48,
    rx: 2,
    transform: "matrix(1 0 0 -1 35.5 57)",
    fill: "#D1D4DC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.75,
    height: 48,
    rx: 2,
    transform: "matrix(1 0 0 -1 48.25 57)",
    fill: "#D1D4DC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 63,
    height: 63,
    rx: 3.5,
    stroke: "#D1D4DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "4columns_svg__filter0_d_2083_169449",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2083_169449"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2083_169449",
    result: "shape"
  })))));
}
export default Svg4Columns;